var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      staticClass: "sl-modal",
      attrs: {
        id: "orderManagement",
        maximized: _vm.maximized,
        "content-css": { minWidth: "80vw", minHeight: "60vh" },
        "no-esc-dismiss": true,
        "no-backdrop-dismiss": true
      },
      model: {
        value: _vm.orderManagementModal.open,
        callback: function($$v) {
          _vm.$set(_vm.orderManagementModal, "open", $$v)
        },
        expression: "orderManagementModal.open"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-icon", { attrs: { name: "cloud upload" } }),
              _c("q-toolbar-title", [
                _vm._v("\n        Order Management\n      ")
              ]),
              _c("q-icon", {
                staticClass: "gt-sm",
                attrs: { size: "20px", name: "filter_none" },
                nativeOn: {
                  click: function($event) {
                    _vm.toggleMaximized()
                  }
                }
              }),
              _c("q-icon", {
                attrs: { name: "clear" },
                nativeOn: {
                  click: function($event) {
                    _vm.closeOrderManagementModal()
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-toolbar",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _vm.orderManagementModal.selectedTab === "users"
                ? _c("q-btn", {
                    attrs: {
                      label: "Remove",
                      color: "red",
                      disable: _vm.selectedUserOverrides.length <= 0
                    },
                    on: {
                      click: function($event) {
                        _vm.onRemoveUserOverrides()
                      }
                    }
                  })
                : _vm._e(),
              _vm.orderManagementModal.selectedTab === "courses"
                ? _c("q-btn", {
                    attrs: {
                      label: "Remove",
                      color: "red",
                      disable: _vm.selectedCourseOverrides.length <= 0
                    },
                    on: {
                      click: function($event) {
                        _vm.onRemoveCourseOverrides()
                      }
                    }
                  })
                : _vm._e(),
              _vm.orderManagementModal.selectedTab === "affiliates"
                ? _c("q-btn", {
                    attrs: {
                      label: "Remove",
                      color: "red",
                      disable: _vm.selectedAffiliateOverrides.length <= 0
                    },
                    on: {
                      click: function($event) {
                        _vm.onRemoveAffiliateOverrides()
                      }
                    }
                  })
                : _vm._e(),
              _c("q-toolbar-title"),
              _vm.orderManagementModal.selectedTab === "details"
                ? _c("q-btn", {
                    attrs: { label: "Save", color: "green" },
                    on: {
                      click: function($event) {
                        _vm.onSaveOrderType()
                      }
                    }
                  })
                : _vm._e(),
              _vm.orderManagementModal.selectedTab === "users"
                ? _c("q-btn", {
                    attrs: {
                      label: "Save",
                      color: "green",
                      disable: _vm.selectedUserOverrides.length <= 0
                    },
                    on: {
                      click: function($event) {
                        _vm.onSaveUserOverrides()
                      }
                    }
                  })
                : _vm._e(),
              _vm.orderManagementModal.selectedTab === "courses"
                ? _c("q-btn", {
                    attrs: {
                      label: "Save",
                      color: "green",
                      disable: _vm.selectedCourseOverrides.length <= 0
                    },
                    on: {
                      click: function($event) {
                        _vm.onSaveCourseOverrides()
                      }
                    }
                  })
                : _vm._e(),
              _vm.orderManagementModal.selectedTab === "affiliates"
                ? _c("q-btn", {
                    attrs: {
                      label: "Save",
                      color: "green",
                      disable: _vm.selectedAffiliateOverrides.length <= 0
                    },
                    on: {
                      click: function($event) {
                        _vm.onSaveAffiliateOverrides()
                      }
                    }
                  })
                : _vm._e(),
              _c("q-btn", {
                staticStyle: { "margin-left": "6px" },
                attrs: { color: "secondary", outline: "", label: "Close" },
                nativeOn: {
                  click: function($event) {
                    _vm.closeOrderManagementModal()
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "layout-padding",
              attrs: { id: "orderManagementBody" }
            },
            [
              _c("div", { staticClass: "sl-row sl-abs" }, [
                _c(
                  "div",
                  {
                    staticClass: "sl-col-3 navigation",
                    staticStyle: { padding: "30px 24px" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c("q-select", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.addOrderType,
                              expression: "!addOrderType"
                            }
                          ],
                          staticClass: "col-8",
                          attrs: {
                            "float-label": "Order Type",
                            options: _vm.orderTypeOptions,
                            value: _vm.orderTypeForm.ORDER_TYPE_ID
                          },
                          on: {
                            change: function(val) {
                              return _vm.selectOrderType(val)
                            }
                          }
                        }),
                        _c("q-input", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.addOrderType,
                              expression: "addOrderType"
                            }
                          ],
                          staticClass: "col-8",
                          attrs: {
                            "float-label": "Enter Order Type",
                            value: _vm.orderTypeForm.ORDER_TYPE_NAME
                          },
                          on: {
                            input: function(val) {
                              return _vm.updateOrderTypeForm({
                                field: "ORDER_TYPE_NAME",
                                value: val
                              })
                            }
                          }
                        }),
                        _c(
                          "q-btn",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.addOrderType,
                                expression: "!addOrderType"
                              }
                            ],
                            staticClass: "col-2 q-ml-md",
                            attrs: {
                              id: "addOrderType",
                              flat: "",
                              icon: "add"
                            },
                            on: {
                              click: function($event) {
                                _vm.onAddOrderType()
                              }
                            }
                          },
                          [
                            _c(
                              "q-tooltip",
                              {
                                attrs: {
                                  anchor: "center right",
                                  self: "center left",
                                  offset: [10, 10]
                                }
                              },
                              [_vm._v("Add an Order Type")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-btn",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.addOrderType,
                                expression: "addOrderType"
                              }
                            ],
                            staticClass: "col-2",
                            attrs: {
                              id: "submitOrderType",
                              flat: "",
                              color: "green",
                              icon: "check"
                            },
                            on: {
                              click: function($event) {
                                _vm.onSubmitOrderType()
                              },
                              "": function($event) {}
                            }
                          },
                          [
                            _c(
                              "q-tooltip",
                              {
                                attrs: {
                                  anchor: "center right",
                                  self: "center left",
                                  offset: [10, 10]
                                }
                              },
                              [_vm._v("Submit New Order Type")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-btn",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.addOrderType,
                                expression: "addOrderType"
                              }
                            ],
                            staticClass: "col-2",
                            attrs: {
                              id: "cancelOrderType",
                              flat: "",
                              color: "red",
                              icon: "clear"
                            },
                            on: {
                              click: function($event) {
                                _vm.onClearOrderType()
                              }
                            }
                          },
                          [
                            _c(
                              "q-tooltip",
                              {
                                attrs: {
                                  anchor: "center right",
                                  self: "center left",
                                  offset: [10, 10]
                                }
                              },
                              [_vm._v("Cancel New Order Type")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm.orderTypeForm.ORDER_TYPE_ID
                      ? _c(
                          "q-list",
                          { attrs: { highlight: "" } },
                          [
                            _c(
                              "q-item",
                              {
                                class: {
                                  active:
                                    _vm.orderManagementModal.selectedTab ===
                                    "details"
                                },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.updateSelectedTab("details")
                                  }
                                }
                              },
                              [
                                _c("q-item-main", {
                                  attrs: { label: "Overview" }
                                })
                              ],
                              1
                            ),
                            _c("q-item-separator"),
                            _vm.orderTypeForm.ORDER_TYPE_ID
                              ? _c(
                                  "div",
                                  [
                                    _c("q-list-header", [_vm._v("Overrides")]),
                                    _c(
                                      "q-item",
                                      {
                                        class: {
                                          active:
                                            _vm.orderManagementModal
                                              .selectedTab === "courses"
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            _vm.updateSelectedTab("courses")
                                          }
                                        }
                                      },
                                      [
                                        _c("q-item-main", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !_vm.addCourseOverride,
                                              expression: "!addCourseOverride"
                                            }
                                          ],
                                          attrs: { label: "Courses" }
                                        }),
                                        _c(
                                          "q-item-main",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.addCourseOverride,
                                                expression: "addCourseOverride"
                                              }
                                            ]
                                          },
                                          [
                                            _c(
                                              "q-field",
                                              {
                                                attrs: {
                                                  "error-label": "Invalid Date"
                                                }
                                              },
                                              [
                                                _c(
                                                  "q-search",
                                                  {
                                                    model: {
                                                      value: _vm.courseFilter,
                                                      callback: function($$v) {
                                                        _vm.courseFilter = $$v
                                                      },
                                                      expression: "courseFilter"
                                                    }
                                                  },
                                                  [
                                                    _c("q-autocomplete", {
                                                      ref: "courseAutoComplete",
                                                      attrs: {
                                                        "float-label":
                                                          "Search Users",
                                                        debounce: 500,
                                                        "max-results":
                                                          _vm.maxResults
                                                      },
                                                      on: {
                                                        search:
                                                          _vm.onSearchCourse,
                                                        selected:
                                                          _vm.onSelectCourse
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "q-item-side",
                                          [
                                            _c(
                                              "q-item-tile",
                                              [
                                                _c(
                                                  "q-btn",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: !_vm.addCourseOverride,
                                                        expression:
                                                          "!addCourseOverride"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "addOverrideBtn",
                                                    attrs: { icon: "add" },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.onAddCourseOverride()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "q-tooltip",
                                                      {
                                                        attrs: {
                                                          anchor:
                                                            "center right",
                                                          self: "center left",
                                                          offset: [10, 10]
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Add a Course Override"
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "q-btn",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.addCourseOverride,
                                                        expression:
                                                          "addCourseOverride"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "clearOverrideBtn",
                                                    attrs: {
                                                      flat: "",
                                                      color: "red",
                                                      icon: "clear"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.onClearCourseOverride()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "q-tooltip",
                                                      {
                                                        attrs: {
                                                          anchor:
                                                            "center right",
                                                          self: "center left",
                                                          offset: [10, 10]
                                                        }
                                                      },
                                                      [_vm._v("Clear")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "q-item",
                                      {
                                        class: {
                                          active:
                                            _vm.orderManagementModal
                                              .selectedTab === "users"
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            _vm.updateSelectedTab("users")
                                          }
                                        }
                                      },
                                      [
                                        _c("q-item-main", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !_vm.addUserOverride,
                                              expression: "!addUserOverride"
                                            }
                                          ],
                                          attrs: { label: "Users" }
                                        }),
                                        _c(
                                          "q-item-main",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.addUserOverride,
                                                expression: "addUserOverride"
                                              }
                                            ]
                                          },
                                          [
                                            _c(
                                              "q-search",
                                              {
                                                attrs: {
                                                  "float-label": "Search Users"
                                                },
                                                model: {
                                                  value: _vm.userFilter,
                                                  callback: function($$v) {
                                                    _vm.userFilter = $$v
                                                  },
                                                  expression: "userFilter"
                                                }
                                              },
                                              [
                                                _c("q-autocomplete", {
                                                  ref: "userAutoComplete",
                                                  attrs: {
                                                    debounce: 500,
                                                    "max-results":
                                                      _vm.maxResults
                                                  },
                                                  on: {
                                                    search: _vm.onSearchUser,
                                                    selected: _vm.onSelectUser
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "q-item-side",
                                          [
                                            _c(
                                              "q-item-tile",
                                              [
                                                _c(
                                                  "q-btn",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: !_vm.addUserOverride,
                                                        expression:
                                                          "!addUserOverride"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "addOverrideBtn",
                                                    attrs: { icon: "add" },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.onAddUserOverride()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "q-tooltip",
                                                      {
                                                        attrs: {
                                                          anchor:
                                                            "center right",
                                                          self: "center left",
                                                          offset: [10, 10]
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Add a User Override"
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "q-btn",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.addUserOverride,
                                                        expression:
                                                          "addUserOverride"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "clearOverrideBtn",
                                                    attrs: {
                                                      flat: "",
                                                      color: "red",
                                                      icon: "clear"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.onClearUserOverride()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "q-tooltip",
                                                      {
                                                        attrs: {
                                                          anchor:
                                                            "center right",
                                                          self: "center left",
                                                          offset: [10, 10]
                                                        }
                                                      },
                                                      [_vm._v("Clear")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "q-item",
                                      {
                                        class: {
                                          active:
                                            _vm.orderManagementModal
                                              .selectedTab === "affiliates"
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            _vm.updateSelectedTab("affiliates")
                                          }
                                        }
                                      },
                                      [
                                        _c("q-item-main", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !_vm.addAffiliateOverride,
                                              expression:
                                                "!addAffiliateOverride"
                                            }
                                          ],
                                          attrs: { label: "Affiliates" }
                                        }),
                                        _c(
                                          "q-item-main",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.addAffiliateOverride,
                                                expression:
                                                  "addAffiliateOverride"
                                              }
                                            ]
                                          },
                                          [
                                            _c(
                                              "q-search",
                                              {
                                                attrs: {
                                                  "float-label":
                                                    "Search Affiliates"
                                                },
                                                model: {
                                                  value: _vm.affiliateFilter,
                                                  callback: function($$v) {
                                                    _vm.affiliateFilter = $$v
                                                  },
                                                  expression: "affiliateFilter"
                                                }
                                              },
                                              [
                                                _c("q-autocomplete", {
                                                  ref: "affiliateAutoComplete",
                                                  attrs: {
                                                    debounce: 500,
                                                    "max-results":
                                                      _vm.maxResults
                                                  },
                                                  on: {
                                                    search:
                                                      _vm.onSearchAffiliate,
                                                    selected:
                                                      _vm.onSelectAffiliate
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "q-item-side",
                                          [
                                            _c(
                                              "q-item-tile",
                                              [
                                                _c(
                                                  "q-btn",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: !_vm.addAffiliateOverride,
                                                        expression:
                                                          "!addAffiliateOverride"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "addOverrideBtn",
                                                    attrs: { icon: "add" },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.onAddAffiliateOverride()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "q-tooltip",
                                                      {
                                                        attrs: {
                                                          anchor:
                                                            "center right",
                                                          self: "center left",
                                                          offset: [10, 10]
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Add a Affiliate Override"
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "q-btn",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.addAffiliateOverride,
                                                        expression:
                                                          "addAffiliateOverride"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "clearOverrideBtn",
                                                    attrs: {
                                                      flat: "",
                                                      color: "red",
                                                      icon: "clear"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.onClearAffiliateOverride()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "q-tooltip",
                                                      {
                                                        attrs: {
                                                          anchor:
                                                            "center right",
                                                          self: "center left",
                                                          offset: [10, 10]
                                                        }
                                                      },
                                                      [_vm._v("Clear")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "sl-col-9 sl-vp no-padding full-height",
                    staticStyle: { "padding-bottom": "60px" },
                    attrs: { id: "class-modal-right" }
                  },
                  [
                    _vm.orderManagementModal.selectedTab === "details"
                      ? _c("div", { staticClass: "full-height" }, [
                          _vm.orderTypeForm.ORDER_TYPE_ID === undefined
                            ? _c("div", { staticClass: "absolute-center" }, [
                                _c(
                                  "span",
                                  { staticClass: "label bg-primary" },
                                  [_vm._v("Please Select an Order Type!")]
                                )
                              ])
                            : _c(
                                "div",
                                { staticClass: "q-pa-lg fit" },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c("h5", [_vm._v("Defaults")])
                                  ]),
                                  _c("div", { staticClass: "q-pb-sm" }, [
                                    _c(
                                      "div",
                                      { staticClass: "row" },
                                      [
                                        _c(
                                          "q-field",
                                          { staticClass: "q-pa-md col-4" },
                                          [
                                            _c("q-input", {
                                              attrs: {
                                                "float-label": "Name",
                                                value:
                                                  _vm.orderTypeForm
                                                    .ORDER_TYPE_NAME
                                              },
                                              on: {
                                                input: function(val) {
                                                  return _vm.updateOrderTypeForm(
                                                    {
                                                      field: "ORDER_TYPE_NAME",
                                                      value: val
                                                    }
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "q-field",
                                          { staticClass: "q-pa-md col-4" },
                                          [
                                            _c("q-input", {
                                              attrs: {
                                                "stack-label": "Price",
                                                type: "number",
                                                prefix: "$",
                                                value: _vm.orderTypeForm.PRICE
                                              },
                                              on: {
                                                input: function(val) {
                                                  return _vm.updateOrderTypeForm(
                                                    {
                                                      field: "PRICE",
                                                      value: val
                                                    }
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "row" },
                                      [
                                        _c(
                                          "q-field",
                                          { staticClass: "q-pa-md col-4" },
                                          [
                                            _c("q-input", {
                                              attrs: {
                                                "stack-label": "Minimum Amount",
                                                type: "number",
                                                prefix: "x",
                                                min: 0,
                                                value:
                                                  _vm.orderTypeForm.MIN_AMOUNT
                                              },
                                              on: {
                                                input: function(val) {
                                                  return _vm.updateOrderTypeForm(
                                                    {
                                                      field: "MIN_AMOUNT",
                                                      value: val
                                                    }
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "q-field",
                                          { staticClass: "q-pa-md col-4" },
                                          [
                                            _c("q-input", {
                                              attrs: {
                                                "stack-label": "Maximum Amount",
                                                type: "number",
                                                prefix: "x",
                                                min: 0,
                                                value:
                                                  _vm.orderTypeForm.MAX_AMOUNT
                                              },
                                              on: {
                                                input: function(val) {
                                                  return _vm.updateOrderTypeForm(
                                                    {
                                                      field: "MAX_AMOUNT",
                                                      value: val
                                                    }
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "h5",
                                      [
                                        _vm._v(
                                          " Shipping Methods\n                  "
                                        ),
                                        _c(
                                          "q-btn",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.orderTypeForm
                                                    .SHIPPING_METHODS.length <
                                                  _vm.shippingTypeOptions
                                                    .length,
                                                expression:
                                                  "orderTypeForm.SHIPPING_METHODS.length < shippingTypeOptions.length"
                                              }
                                            ],
                                            attrs: {
                                              icon: "add",
                                              id: "addShippingType"
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.addShipping()
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "q-tooltip",
                                              {
                                                attrs: {
                                                  anchor: "center right",
                                                  self: "center left",
                                                  offset: [10, 10]
                                                }
                                              },
                                              [_vm._v("Add a Shipping Type")]
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.orderTypeForm
                                                    .SHIPPING_METHODS.length ===
                                                  0,
                                                expression:
                                                  "orderTypeForm.SHIPPING_METHODS.length === 0"
                                              }
                                            ]
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "label bg-primary"
                                              },
                                              [
                                                _vm._v(
                                                  "Please Add a Shipping Type!"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._l(
                                    _vm.orderTypeForm.SHIPPING_METHODS,
                                    function(shippingMethod, index) {
                                      return _c(
                                        "div",
                                        { key: index, staticClass: "row" },
                                        [
                                          _c(
                                            "q-field",
                                            {
                                              staticClass: "q-pa-md col-4",
                                              attrs: {
                                                error:
                                                  _vm.$v.orderTypeForm
                                                    .SHIPPING_METHODS.$each[
                                                    index
                                                  ].LK_SHIPPING_TYPE_ID.$error
                                              }
                                            },
                                            [
                                              _c("q-select", {
                                                attrs: {
                                                  "float-label":
                                                    "Shipping Type",
                                                  options: _vm.remainingShippingTypeOptions(
                                                    shippingMethod.LK_SHIPPING_TYPE_ID
                                                  )
                                                },
                                                on: {
                                                  blur:
                                                    _vm.$v.orderTypeForm
                                                      .SHIPPING_METHODS.$each[
                                                      index
                                                    ].LK_SHIPPING_TYPE_ID.$touch
                                                },
                                                model: {
                                                  value:
                                                    shippingMethod.LK_SHIPPING_TYPE_ID,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      shippingMethod,
                                                      "LK_SHIPPING_TYPE_ID",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "shippingMethod.LK_SHIPPING_TYPE_ID"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "q-field",
                                            {
                                              staticClass: "q-pa-md col-2",
                                              attrs: {
                                                error:
                                                  _vm.$v.orderTypeForm
                                                    .SHIPPING_METHODS.$each[
                                                    index
                                                  ].PRICE.$error
                                              }
                                            },
                                            [
                                              _c("q-input", {
                                                attrs: {
                                                  type: "number",
                                                  "stack-label": "Price",
                                                  prefix: "$"
                                                },
                                                on: {
                                                  blur:
                                                    _vm.$v.orderTypeForm
                                                      .SHIPPING_METHODS.$each[
                                                      index
                                                    ].PRICE.$touch
                                                },
                                                model: {
                                                  value: shippingMethod.PRICE,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      shippingMethod,
                                                      "PRICE",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "shippingMethod.PRICE"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "q-field",
                                            { staticClass: "q-pa-md col-2" },
                                            [
                                              _c("q-input", {
                                                attrs: {
                                                  type: "number",
                                                  "stack-label": "Item Limit",
                                                  prefix: "x"
                                                },
                                                model: {
                                                  value:
                                                    shippingMethod.ITEM_LIMIT,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      shippingMethod,
                                                      "ITEM_LIMIT",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "shippingMethod.ITEM_LIMIT"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "q-field",
                                            { staticClass: "q-ma-lg col-2" },
                                            [
                                              _c("q-toggle", {
                                                attrs: { label: "Default" },
                                                on: {
                                                  input: function($event) {
                                                    _vm.forceSingleDefault(
                                                      index,
                                                      _vm.orderTypeForm
                                                        .SHIPPING_METHODS
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    shippingMethod.IS_DEFAULT,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      shippingMethod,
                                                      "IS_DEFAULT",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "shippingMethod.IS_DEFAULT"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c("q-btn", {
                                            staticClass: "float-right",
                                            attrs: {
                                              size: "md",
                                              icon: "delete"
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.removeShippingMethod(index)
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  _vm.orderTypeForm &&
                                  _vm.orderTypeForm.DELETABLE_IND
                                    ? _c("q-btn", {
                                        staticStyle: { "margin-top": "60px" },
                                        attrs: {
                                          color: "red",
                                          outline: "",
                                          icon: "delete",
                                          label: "Delete Order Type",
                                          disabled:
                                            !!_vm.orderTypeForm.ORDER_TYPE_ID ||
                                            _vm.orderTypeForm.DELETABLE_IND ===
                                              0
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            _vm.onDeleteOrderType()
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                2
                              )
                        ])
                      : _vm._e(),
                    _vm.orderManagementModal.selectedTab === "users"
                      ? _c(
                          "div",
                          { attrs: { id: "usersContainer" } },
                          [_c("order-user-overrides")],
                          1
                        )
                      : _vm._e(),
                    _vm.orderManagementModal.selectedTab === "courses"
                      ? _c(
                          "div",
                          { attrs: { id: "coursesContainer" } },
                          [_c("order-course-overrides")],
                          1
                        )
                      : _vm._e(),
                    _vm.orderManagementModal.selectedTab === "affiliates"
                      ? _c("div", [_c("order-affiliate-overrides")], 1)
                      : _vm._e()
                  ]
                )
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }